// ============= Imports =============
import { tokenManager } from '@tw/tw-component-library';

// ============= Constants =============
const BASE_URL = import.meta.env.VITE_BASE_CORE_URL;
const API_ENDPOINT = '/api/Aderant/matters';
const LITIUM_SCOPE = import.meta.env.VITE_LITIUM_CORE_SCOPE;
const HEADERS = {};

// ============= Types =============

// ============= Utility Functions =============
/**
 * Constructs filter parameters for API query
 * @param searchValue Search term to filter users
 * @returns Formatted filter string
 */
// const constructFilterParams = (searchValue: string): string => {
//   return [
//     `startswith(givenName,'${searchValue}')`,
//     `startswith(surname,'${searchValue}')`,
//     `startswith(userPrincipalName,'${searchValue}')`,
//   ].join(' or ');
// };

/**
 * Creates headers for API request
 * @param token Authentication token
 * @returns Headers object
 */
const createHeaders = (token: string) => ({
  Authorization: `Bearer ${token}`,
  ...HEADERS,
});

// ============= Main Function =============
/**
 * Fetches users from Microsoft API based on search criteria
 * @param getAccessToken Function to acquire access token
 * @param searchValue Search string to filter users
 * @returns Promise with API response containing user data or error
 */
export const fetchMatters = async ({
  getAccessToken,
  searchValue,
  office,
}: any): Promise<any> => {
  try {
    console.log('🔄 Fetching API data...');

    const isNumeric = (str: string): boolean => {
      // Use a regular expression to check if the string contains only digits.
      // ^ asserts position at the start of the string.
      // \d matches a digit (0-9).
      // + matches the previous token between one and unlimited times (at least one digit).
      // $ asserts position at the end of the string.
      return /^\d+$/.test(str);
    };

    // Determine query parameter key and value based on whether searchValue is a number
    const queryParamKey = isNumeric(searchValue) ? 'clientUno' : 'searchTerm';
    const queryParamValue = searchValue;

    // Token acquisition with required scopes

    const token = await getAccessToken([LITIUM_SCOPE]);
    if (!token) {
      throw new Error('Failed to acquire API token');
    }
    tokenManager.logTokenInfo(token, 'API');

    // URL construction
    const url = `${BASE_URL}${API_ENDPOINT}?${queryParamKey}=${queryParamValue}&office=${office}`;
    const convertURI = encodeURI(url);
    console.log('🌐 Making request to:', convertURI);

    // API request
    const response = await fetch(convertURI, {
      method: 'GET',
      headers: createHeaders(token),
    });

    // Response handling
    if (!response.ok) {
      console.log(`HTTP error! status: ${response.status}`);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ API data fetched successfully');

    return {
      success: true,
      data,
    };
  } catch (error) {
    console.error('🔴 Error fetching API data:', error);
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unknown error occurred',
    };
  }
};
